/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { documentsGetChunk } from "../../funcs/documentsGetChunk.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetDocumentChunkRequest$inboundSchema,
};

export const tool$documentsGetChunk: ToolDefinition<typeof args> = {
  name: "documents-get-chunk",
  description: `Get Document Chunk

Gets a document chunk by its document and chunk ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await documentsGetChunk(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
